var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_21922)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4114 48.5218C24.1391 48.2495 23.904 47.9154 23.7555 47.5442C23.4214 46.7151 23.4585 45.787 23.8669 44.9827L24.9558 42.8048C25.4508 41.8149 26.6016 41.1095 27.703 41.0971L33.3333 41.0848C33.4075 41.0848 33.5932 40.9981 33.655 40.9363L36.7115 37.8798L28.631 34.6748C27.5545 34.2417 26.8244 33.4374 26.6264 32.4722C26.4284 31.507 26.7749 30.4676 27.5792 29.6632L29.1755 28.0669C30.3882 26.8542 32.5537 26.4211 34.0881 27.0894L43.6783 30.8883L47.1926 27.374C48.6899 25.8767 51.4617 25.2084 53.4911 25.8519C54.4563 26.1736 55.1988 26.9161 55.5082 27.8689C56.164 29.9107 55.5082 32.6702 54.0109 34.1675L50.4965 37.6818L54.3326 47.3091C54.9637 48.8806 54.543 50.9843 53.3179 52.2093L51.7216 53.8056C50.9049 54.6223 49.8902 54.9688 48.9126 54.7584C47.935 54.5481 47.1431 53.8304 46.6976 52.7662L43.4927 44.6857L40.4362 47.7422C40.3867 47.7917 40.3124 47.9649 40.3124 48.0392L40.3001 53.6942C40.3001 54.7832 39.57 55.9588 38.5924 56.4414L36.4145 57.5303C35.5978 57.9263 34.6697 57.9634 33.8406 57.6045C33.0239 57.2581 32.4052 56.5898 32.1206 55.7608C32.0959 55.6618 32.0711 55.5628 32.0587 55.4514L31.6009 50.1428C31.5885 49.9572 31.3781 49.7716 31.2173 49.7592L25.9087 49.3013C25.8097 49.3013 25.7107 49.2766 25.6241 49.2395C25.1538 49.1157 24.7455 48.8559 24.4114 48.5218ZM39.1245 36.234C39.4091 36.5186 39.6071 36.8651 39.6813 37.2611C39.8298 37.9788 39.5947 38.7089 39.0255 39.2781L35.4988 42.8048C34.9667 43.3369 34.0758 43.7081 33.3333 43.7081L27.703 43.7205C27.5916 43.7329 27.3565 43.869 27.307 43.968L26.2057 46.1583C26.119 46.3191 26.1562 46.4552 26.1809 46.5295C26.2057 46.579 26.2428 46.6656 26.3418 46.7151L31.4524 47.1482C32.9002 47.2596 34.1253 48.4846 34.2366 49.9324L34.6697 55.0183C34.744 55.1173 34.8182 55.1668 34.8677 55.1915C34.942 55.2163 35.0905 55.2658 35.2513 55.1792L37.4292 54.0902C37.5406 54.0284 37.6767 53.7932 37.6767 53.6942L37.6891 48.0639C37.6643 47.3462 38.0356 46.4305 38.58 45.886L42.1067 42.3593C42.6636 41.8025 43.3813 41.555 44.0866 41.6911C44.792 41.8272 45.3736 42.3346 45.6705 43.077L49.1354 51.7886C49.2467 52.0485 49.3705 52.1722 49.4323 52.1846C49.4942 52.1969 49.6551 52.1351 49.8531 51.9371L51.4494 50.3408C51.9196 49.8706 52.13 48.8682 51.8825 48.2743L47.9598 38.3871C47.6504 37.6076 47.8608 36.63 48.4548 36.036L52.1671 32.3237C52.9838 31.507 53.3921 29.8117 53.0209 28.698C52.9714 28.5495 52.8477 28.4258 52.6868 28.3639C51.5979 28.0174 49.8655 28.4382 49.0611 29.2425L45.3488 32.9548C44.7672 33.5364 43.7773 33.7591 42.9977 33.4498L33.1106 29.5271C32.5042 29.2672 31.5019 29.4776 31.044 29.9355L29.4477 31.5317C29.2498 31.7297 29.1879 31.8906 29.2003 31.9525C29.2126 32.0144 29.3364 32.1381 29.5962 32.2495L38.2954 35.7019C38.6171 35.8257 38.9018 36.0113 39.1245 36.234Z",
    fill: "url(#paint0_linear_19_21922)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_21922",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_21922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_21922",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_21922",
    x1: 54.7533,
    y1: 26.6315,
    x2: 28.6372,
    y2: 52.7476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.06fc59de5237a5e9e8f7b1995afacda0.svg";
export { ForwardRef as ReactComponent };